/**
 * 小売開栓結果登録API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ガス契約情報
 */
export interface Sgkb121aReqGasConInfoDto {
    /** 
     * ガス業種小分類：半角数字
     */
    gasGyoshuSmallbunrui?: string;
}
